class AppData {
  private data: Map<string, unknown> = new Map();

  public setData(key: string, value: unknown): void {
    this.data.set(key, value);
  }

  public getData<T>(key: string): T | undefined {
    return this.data.get(key) as T;
  }

  public clearData(key: string): void {
    this.data.delete(key);
  }
}

export const appData = new AppData();
